import "../css/companycard.css";
import React from "react";
import { ReactComponent as RupeeIcon } from "../assets/icons/rupee.svg";
import { Tooltip } from "@mui/material";

export const currencyConfig = {
  INR: { type: "rupee", width: 54, height: 72 },
  USD: { symbol: "$", width: 70, height: 80, viewBox: "0 0 70 105", fontSize: 100 },
  EUR: { symbol: "€", width: 70, height: 80, viewBox: "0 0 70 105", fontSize: 100 },
  GBP: { symbol: "£", width: 70, height: 80, viewBox: "0 0 70 105", fontSize: 100 },
  PHP: { symbol: "₱", width: 70, height: 80, viewBox: "0 0 70 105", fontSize: 100 },
  LKR: { symbol: "Rs", width: 130, height: 80, viewBox: "0 0 130 105", fontSize: 100 },
  AUD: { symbol: "A$", width: 125, height: 80, viewBox: "0 0 125 105", fontSize: 100 },
  CAD: { symbol: "C$", width: 125, height: 80, viewBox: "0 0 125 105", fontSize: 100 },
  SGD: { symbol: "S$", width: 125, height: 80, viewBox: "0 0 125 105", fontSize: 100 },
  CHF: { symbol: "CHF", width: 170, height: 80, viewBox: "0 0 170 105", fontSize: 100 },
};

export const CurrencyWatermark = ({ currency, width, height }) => {
  const code = (currency || "").trim().toUpperCase();
  if (code === "INR" || !code || code === "N/A") {
    return <RupeeIcon width={width || 54} height={height || 72} />;
  }

  const config = currencyConfig[code] || {
    symbol: code,
    width: code.length >= 3 ? 170 : code.length === 2 ? 125 : 70,
    height: 80,
    viewBox: code.length >= 3 ? "0 0 170 105" : code.length === 2 ? "0 0 125 105" : "0 0 70 105",
    fontSize: 100,
  };

  return (
    <svg
      width={width || config.width}
      height={height || config.height}
      viewBox={config.viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        fontWeight="700"
        fontSize={config.fontSize}
        fill="#EAEEED"
      >
        {config.symbol}
      </text>
    </svg>
  );
};

const CompanyCard = ({
  leftImage,
  rightIcon,
  companyName,
  tag,
  functionalCurrency,
  min = false,
}) => {
  const watermark =
    rightIcon !== undefined ? (
      rightIcon
    ) : (
      <CurrencyWatermark currency={functionalCurrency} />
    );

  const isWideCurrency = ["LKR", "AUD", "CAD", "SGD", "CHF"].includes(
    (functionalCurrency || "").trim().toUpperCase()
  );
  const truncateLimit = isWideCurrency ? 18 : 26;

  return (
    <div className={`${min ? "min-company-card" : "company-card"}`}>
      <div className="company-card-image left-image">
        {/* <img src={leftImage} alt="Left" /> */}
        {leftImage}
      </div>
      <div className="card-content">
        <Tooltip
          title={companyName || ""}
          placement="right"
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: "#000000 !important",
                color: "#ffffff !important",
                fontSize: "15px !important",
                fontFamily: "'DM Sans', sans-serif !important",
                fontWeight: 500,
                borderRadius: "4px !important",
                padding: "5px 10px !important",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.25) !important",
                "& .MuiTooltip-arrow": {
                  color: "#000000 !important",
                },
              },
            },
            arrow: {
              sx: {
                color: "#000000 !important",
              },
            },
          }}
        >
          <span className="company-label">
            {companyName ? (
              companyName?.length > truncateLimit ? (
                companyName.substring(0, truncateLimit - 2).concat("...")
              ) : (
                companyName
              )
            ) : (
              companyName
            )}
          </span>
        </Tooltip>
        <span>{tag}</span>
        <span>
          <span className="currency-label">Currency </span>
          <span className="currency-val">{functionalCurrency || "N/A"}</span>
        </span>
      </div>
      <span className="right-icon">{watermark}</span>
    </div>
  );
};

export default CompanyCard;

